// Forwarded emails (e.g. Gmail) often bake in a fixed pixel width from the sender's compose window,
// far wider than a preview pane, which forces a mostly-empty horizontal scrollbar. Cap element widths to fit.
const RESET_STYLE = `<style>
    html, body { margin: 0; padding: 8px; }
    body * { max-width: 100% !important; box-sizing: border-box; }
    img, table { height: auto !important; }
</style>`;

export function wrapEmailHtmlForPreview(html: string): string {
    return RESET_STYLE + html;
}
